/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".speedbump_button[_ngcontent-%COMP%]{white-space:normal;text-align:left}.speedbump-modal[_ngcontent-%COMP%]   #speedbump-header[_ngcontent-%COMP%]{padding:.8em;background-color:#07639d;color:#fff}.speedbump-modal[_ngcontent-%COMP%]   #speedbump-header[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:currentColor;display:inline-block;max-height:40px;max-width:100%}"];
export { styles as styles };
